import React, { useEffect, useMemo, useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Typography,
  Checkbox,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/CommonSlice";
import { CustomMessage } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import { assetFamilyMaster, InspectionColumnMaster, InspectionMasterList, columnsInspectionCheckList, InspectionTemplateMaster, InspectionTypeType, TemplateColumnMaster } from "../../types/assetTypes";
import { getFamilyAssetMasterDataList, getInspectionTemplateList, getInspectionTypeList, saveInspectionTemplate, saveServiceTemplate } from "../../api/Services/masterServie";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND, PAGESTART } from "../../api/endpoint";
import ImagePreview from "../../Component/ImagePreview";
import { RootState } from "../../store/Reduxstore";
import { getInspectionTemplateByIdData, getUniqueAssetNamesByFamilyId } from "../../api/Services/assetServices";

interface CreatetTemplateProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  // selectedData: InspectionTemplateMaster;
  // setSelectedData: React.Dispatch<React.SetStateAction<InspectionTemplateMaster>>;
  inspectionTemplateId: number | null;
  setInspectionTemplateId: React.Dispatch<React.SetStateAction<number | null>>;
  userId: number;
}


const CreateTemplate: React.FC<CreatetTemplateProps> = ({ setOpen,
  // selectedData,
  // setSelectedData,crea
  inspectionTemplateId,
  setInspectionTemplateId,
  userId, }) => {
  const dispatch = useDispatch();
  const [inspectionTemplate, setInspectionTemplate] = useState<InspectionTemplateMaster>({
    inspectionTemplateId: 0,
    inspectionTemplateName: "",
    familyAssetId: 0,
    familyAssetName: "",
    columns: [], // Assuming `columns` is an array used in the table
  });

  interface ServiceColumnMap {
    familyAssetId: number;
    assetName: string[];   // multiple asset names
  }

  const [faultAssetMapData, setFaultAssetMapData] = useState<ServiceColumnMap>({
    familyAssetId: 0,
    assetName: [],
  });

  const [templateColumns, setTemplateColumns] = useState<InspectionColumnMaster[]>([]);
  const [familyAsset, setFamilyAsset] = useState<assetFamilyMaster[]>([]);
  const [inspectionTypes, setInspectionTypes] = useState<InspectionTypeType[]>([]);
  const [assetName, setAssetNameList] = useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    if (familyAsset.length === 0) getFamilyAssetList(1, PAGESEND);
  }, [familyAsset]);


  useEffect(() => {
    if (familyAsset.length === 0) getFamilyAssetList(1, PAGESEND);
  }, [familyAsset]);

  useEffect(() => {
    if (inspectionTemplate) {
      console.log("Current Inspection Template:", inspectionTemplate);

      inspectionTemplate.columns?.forEach((column, columnIndex) => {
        console.log(`Column ${columnIndex + 1}:`, column);

        column.inspectionTypeStatuses?.forEach((status) => {
          console.log(
            ` - InspectionTypeId: ${status.inspectionTypeId}, isChecked: ${status.isChecked}`
          );
        });
      });
    }
  }, [inspectionTemplate]);

  useEffect(() => {
    if (inspectionTemplateId !== null) {
      console.log("🔍 inspectionTemplateId changed:", inspectionTemplateId);

      // You can also call an API or set state here if needed
      // Example: fetchTemplateDetails(inspectionTemplateId);
    } else {
      console.log("🚫 inspectionTemplateId is null");
    }
  }, [inspectionTemplateId]);

  useEffect(() => {
    if (inspectionTemplateId !== null && inspectionTemplateId != 0) {
      getInspectionTemplateById();
    }
  }, [inspectionTemplateId]);



  // useEffect(() => {
  // if (inspectionTypes.length > 0) {
  //     getTemplateData();
  // }
  // }, [inspectionTypes]);

  useEffect(() => {
    const fetchInspectionTypes = async () => {
      try {
        const response = await getInspectionTypeList(PAGESTART, PAGESEND, {});
        setInspectionTypes(response.data); // Set inspection types dynamically
      } catch (error) {
        console.error("Failed to fetch inspection types:", error);
      }
    };
    fetchInspectionTypes();
  }, []);

  const getAssetNameList = async (familyAssetId: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getUniqueAssetNamesByFamilyId(familyAssetId);
      if (status.code === 200 && Array.isArray(data) && data.length > 0) {
        const updatedData = data.map((assetName: string) => ({
          value: assetName,
          label: assetName,
        }));
        updatedData.unshift({ label: "--Select--", value: "" });
        setAssetNameList(updatedData);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getFamilyAssetList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getFamilyAssetMasterDataList(page, rows, { familyAssetId: { value: "", matchMode: "startWith" } });
      if (status.code === 200 && data?.length > 0) {
        setFamilyAsset(data);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getInspectionTemplateById = async () => {
    if (!inspectionTemplateId) {
      CustomMessage("Inspection ID not selected", "error", enqueueSnackbar);
      return;
    }

    dispatch(setLoading(true));

    try {
      const response = await getInspectionTemplateByIdData(inspectionTemplateId);
      console.log("API Response:", response);

      const rawData = response.data?.data || response.data;

      if (rawData) {
        const combinedData = {
          ...rawData,
          userId: userId ?? 0,
          columns: rawData.columns?.map((col: any) => ({
            ...col,
            assets: col.assets ?? [], // ensure assets array exists
          })) || [],
          assetName: [] as string[], // initialize assetName as empty array
        };


        if (combinedData.familyAssetId) {
          setFaultAssetMapData(prev => (
            {
              ...prev,
              familyAssetId: combinedData.familyAssetId
            }
          ));
          const assetNames = await getAssetNameList(combinedData.familyAssetId); // assuming this returns string[]
          combinedData.assetName = assetNames;

          console.log("Setting serviceTemplate:", combinedData);

          await getInspectionTemplateData({
            //serviceTemplateId: combinedData.serviceTemplateId,
            assetName: [],
            familyAssetId: combinedData.familyAssetId,
          });
          setInspectionTemplate(combinedData);
        }
      } else {
        CustomMessage("No data found for template ID", "warning", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message || "Failed to fetch data", "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getInspectionTemplateData = async (payload: ServiceColumnMap) => {
    dispatch(setLoading(true));

    try {
      const response = await getInspectionTemplateList(payload);
      const { data, status } = response;

      if (status.code === 200 && data && data.length > 0) {
        // ensure assets always exists
        const mappedData: InspectionColumnMaster[] = data.map((d) => ({
          ...d,
          assets: d.assets ?? [],
        }));

        setTemplateColumns(mappedData);

        setInspectionTemplate((prev) => {
          if (!prev) return prev;

          const updatedData: columnsInspectionCheckList[] = data.map((column) => {
            const existingColumn = prev.columns.find(
              (col) => col.inspectionColumnId === column.inspectionColumnId
            );

            const inspectionTypeStatuses = inspectionTypes.map((type) => {
              const match = existingColumn?.inspectionTypeStatuses?.find(
                (s) => s.inspectionTypeId === type.inspectionTypeId
              );
              return {
                inspectionTypeId: type.inspectionTypeId,
                isChecked: match?.isChecked ?? false,
              };
            });

            return {
              ...column,
              attachments: existingColumn?.attachments || [],
              inspectionTypeStatuses,
            };
          });


          return {
            ...prev,
            columns: updatedData,
          };
        });
      } else {
        CustomMessage(status.message, 'error', enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error.message, 'error', enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };





  const handleClear = () => {
    // setInspectionTemplate({
    //     inspectionTemplateId: 0,
    //     inspectionTemplateName: "",
    //     familyAssetId: 0,
    //     familyAssetName: "",
    //     columns: [],
    // });
    // setSelectedData({
    //     inspectionTemplateId: 0,
    //     inspectionTemplateName: "",
    //     familyAssetId: 0,
    //     familyAssetName: "",
    //     columns: [],
    // });
    setInspectionTemplateId(0);
    setOpen(false);
  }

  const userDetails = useSelector((state: RootState) => state.auth)
  console.log(userDetails);

  // console.log(inspectionTemplate,'inspectionTemplate',selectedData,'selectedData');
  const handleSave = async () => {
    if (!inspectionTemplate) return;

    if (!inspectionTemplate.familyAssetId || inspectionTemplate.familyAssetId === 0) {
      CustomMessage("Please select a Family Asset.", "error", enqueueSnackbar);
      return;
    }

    if (!inspectionTemplate.inspectionTemplateName.trim()) {
      CustomMessage("Service Template Name is required.", "error", enqueueSnackbar);
      return;
    }

    const hasChecked = inspectionTemplate.columns.some((col) =>
      col.inspectionTypeStatuses?.some((type) => type.isChecked)
    );

    if (!hasChecked) {
      CustomMessage("Please check at least one inspection type.", "error", enqueueSnackbar);
      return;
    }

    dispatch(setLoading(true));
    try {
      const payload = {
        ...inspectionTemplate,
        userId: userDetails.userId ?? 0,
        columns: inspectionTemplate.columns.map((col) => ({
          inspectionColumnId: col.inspectionColumnId,
          inspectionColumnName: col.inspectionColumnName,
          attachments: col.attachments || [],
          inspectionTypeStatuses: col.inspectionTypeStatuses.filter((s) => s.isChecked),
          assets: [],
        })),

      };

      const response = await saveInspectionTemplate(payload);
      const { data, status } = response;

      if (status.code === 200 || status.code === 201) {
        handleClear();
        CustomMessage(status.message, "success", enqueueSnackbar);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  return (
    <>
      {inspectionTemplate && (
        <TableContainer
          component={Paper}
          sx={{ maxWidth: "100%", overflowX: "auto", p: 3, boxShadow: 3 }}
        >


          <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
            <FormControl sx={{ minWidth: 200 }}>
              <h6>Select Family</h6>
              <Select
                value={inspectionTemplate.familyAssetId}

                onChange={(e) => {
                  const selectedFamilyId = e.target.value as number;
                  getAssetNameList(e.target.value as number);

                  // update serviceTemplate
                  setInspectionTemplate({
                    ...inspectionTemplate,
                    familyAssetId: selectedFamilyId,
                  });

                  // update faultAssetMapData
                  setFaultAssetMapData({
                    ...faultAssetMapData,
                    familyAssetId: selectedFamilyId,
                  });
                }}
              >
                {familyAsset.map((asset) => (
                  <MenuItem key={asset.familyAssetId} value={asset.familyAssetId}>
                    {asset.familyName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div>
              <h6>Enter Template Name</h6>
              <TextField
                label=""
                variant="outlined"
                value={inspectionTemplate.inspectionTemplateName}
                onChange={(e) => setInspectionTemplate({ ...inspectionTemplate, inspectionTemplateName: e.target.value })}
                sx={{ minWidth: 200 }}
              />
            </div>

            <div style={{ display: "inline-flex", minWidth: 200, maxWidth: "100%" }}>
              <FormControl
                fullWidth
                variant="outlined"
                style={{ borderRadius: 5, flex: 1 }}
              >
                <h6 className="mb-1">Asset Types</h6>
                <Select
                  multiple
                  value={faultAssetMapData.assetName || []}
                  onChange={(e) => {
                    const selectedAssets = e.target.value as string[];

                    // Update local state
                    setFaultAssetMapData({
                      ...faultAssetMapData,
                      assetName: selectedAssets,
                    });

                    // Trigger service template fetch
                    if (faultAssetMapData.familyAssetId) {
                      getInspectionTemplateData({
                        familyAssetId: faultAssetMapData.familyAssetId,
                        assetName: selectedAssets,
                      });
                    }
                  }}
                  displayEmpty

                  renderValue={(selected: any) => {
                    if (!Array.isArray(selected)) return selected || "Select Asset Types";
                    if (selected.length === 0) return "Select Asset Types";

                    // Show max 3, rest as "+x more"
                    const displayItems = selected.slice(0, 3);
                    const extraCount = selected.length - displayItems.length;

                    return extraCount > 0
                      ? `${displayItems.join(", ")} (+${extraCount} more)`
                      : displayItems.join(", ");
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                        width: 250,
                      },
                    },
                  }}
                >
                  <MenuItem disabled value="">
                    Select Asset Types
                  </MenuItem>
                  {assetName.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>

          <Table stickyHeader className="custom-table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", background: "#e0e0e0" }}></TableCell>
                {inspectionTypes.map((type) => (
                  <TableCell key={type.inspectionTypeId} sx={{ fontWeight: "bold", background: "#e0e0e0" }}>
                    {type.inspectionTypeName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>



            <TableBody>
              {inspectionTemplate.columns.map((col, colIndex) => (
                <TableRow key={colIndex}>
                  <TableCell sx={{ fontWeight: "bold", background: "#f5f5f5" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          border: "1px solid #ccc",
                          overflow: "hidden",
                          backgroundColor: "#f5f5f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        {col.attachments?.length > 0 && (
                          <ImagePreview
                            alt="attachment"
                            src={`${FILE_DOWNLOAD_PREVIEW}${col.attachments[0].attachmentId}`}
                            style={{
                              width: "59px",
                              height: "59px",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </div>
                      <span>{col.inspectionColumnName}</span>
                    </div>
                  </TableCell>

                  {inspectionTypes.map((type, typeIndex) => {
                    const typeStatus = col.inspectionTypeStatuses?.find(
                      (s) => s.inspectionTypeId === type.inspectionTypeId
                    );

                    return (
                      <TableCell key={typeIndex}>
                        <Checkbox
                          checked={typeStatus?.isChecked || false}
                          onChange={(e) => {
                            const updatedColumns = [...inspectionTemplate.columns];
                            const columnToUpdate = updatedColumns[colIndex];
                            const updatedStatuses = columnToUpdate.inspectionTypeStatuses.map((s) =>
                              s.inspectionTypeId === type.inspectionTypeId
                                ? { ...s, isChecked: e.target.checked }
                                : s
                            );
                            updatedColumns[colIndex] = {
                              ...columnToUpdate,
                              inspectionTypeStatuses: updatedStatuses,
                            };
                            setInspectionTemplate({
                              ...inspectionTemplate,
                              columns: updatedColumns,
                            });
                          }}
                          color="primary"
                        />
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>


          </Table>

          <div className="d-flex align-items-end justify-content-end gap-1 w-100">
            <ReusablePrimeButton
              label="Cancel"
              onClick={handleClear}
              className="p-button-secondary btn btn-secondary text-white h-45 w120"
            />
            {userDetails.role.some(
              r => r.roleName === "Admin" || r.roleName === "Inspection Template Write"
            ) && (
                <ReusablePrimeButton
                  label="Save"
                  onClick={handleSave}
                  className="p-button-primary btn btn-primary w120 h-45"
                />)}

          </div>

        </TableContainer>
      )}
    </>
  );
};

export default CreateTemplate;
